/**
 * Created by liux on 2017/9/24.
 */

import Vue from 'vue'
import Router from 'vue-router'
import {route as login} from 'bjxy-login/src';

var router = {
  routes: login.concat([
    {path: '/**', redirect: '/login'}
  ])
}

Vue.use(Router);

export default new Router(router);
